// extracted by mini-css-extract-plugin
export default {"quantity_container":"cG","hiddenflavorstring":"eG","loadingLine":"fG","productimgwrap":"gG","productimg":"hG","circlepic":"iG","productinfo":"jG","grey_x":"kG","cartrow":"lG","bold":"mG","title":"nG","blue":"oG","strike":"pG","flexgap":"qG","flavorstring":"rG","nodecorate":"sG","flavorstring_link":"tG","rdstring":"uG","removeditemblock":"vG","removed_heading":"wG","removed_text":"xG","addback":"yG"};
    if(module.hot) {
      // 1713361651614
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  